"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getOrderedCategories = exports.getCategories = exports.getCategory = exports.getCategoryIds = exports.getCategoryId = void 0;
var mapping_1 = require("./mapping");
var category_1 = require("./category");
var map = new Map();
/**
 * 旧id映射到新id，找不到则原路返回
 * @param id
 * @returns
 */
function getCategoryId(id) {
    if (map.size === 0) {
        mapping_1.mapping.forEach(function (id) { return map.set(id[0], id[1]); });
    }
    return map.get(id) || id;
}
exports.getCategoryId = getCategoryId;
/**
 * 批量旧id映射到新id，找不到则原路返回
 * @param ids
 * @returns
 */
function getCategoryIds(ids) {
    if (map.size === 0) {
        mapping_1.mapping.forEach(function (id) { return map.set(id[0], id[1]); });
    }
    return ids.map(function (id) {
        return map.get(id) || id;
    });
}
exports.getCategoryIds = getCategoryIds;
/**
 * 根据id获取对应的category
 * @param id
 * @returns
 */
function getCategory(id) {
    return category_1.categories[getCategoryId(id) + ''];
}
exports.getCategory = getCategory;
/**
 * 根据ids批量获取对应的categories
 * @param ids
 * @returns
 */
function getCategories(ids) {
    var newIds = getCategoryIds(ids);
    return newIds.map(function (id) { return category_1.categories[id + '']; });
}
exports.getCategories = getCategories;
/**
 * 返回排序后的categories
 * @param ids
 * @param country
 * @returns
 */
function getOrderedCategories(ids, country) {
    var key = category_1.PRIORITY_KEY.ID;
    switch (country) {
        case 'ID':
            key = category_1.PRIORITY_KEY.ID;
            break;
        case 'MY':
            key = category_1.PRIORITY_KEY.MY;
            break;
        case 'TH':
            key = category_1.PRIORITY_KEY.TH;
            break;
        default: return [];
    }
    var categories = getCategories(ids);
    // categories里的元素存在undefined的情况，存在priority为0的情况，都需要去除
    return categories.filter(function (category) {
        return !!category && category[key] > 0;
    }).sort(function (c1, c2) {
        return c1[key] - c2[key];
    });
}
exports.getOrderedCategories = getOrderedCategories;
